<template>
	<div>
		<formmain ref="formmain" :windowType="windowType" :width="width" :height="height"
			:flowprogressid="flowprogressid" :loading="loading" @show="show" @hide="hide">
			<template #title>
				<div>{{extra.title?extra.title:title}}</div>
			</template>
			<template #main>
				<div :ref="name+'_form'" style="margin-top: 20px;"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="hide"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</formmain>
		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />
	</div>
</template>
<style scoped>

</style>
<script>
	const formRes = {
		title: '列表字段',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
				"type": "el-button-group",
				"title": "",
				"field": "buildGroup",
				"children": [{
					"type": "el-button",
					"title": "",
					"field": "getcolumns",
					"children": [
						"初始化"
					],
					"props": {
						"type": "danger"
					}
				}],
			}, {
				"type": "$vjsoneditor",
				"field": "listfield",
				"title": "",
				"value": null,
				"labelWidth": "0px",
				"hidden": false,
				"props": {
					"height": "380px",
					"options": {
						"mode": "code"
					}
				},
				"col": {
					"span": 21,
					"offset": 1
				},
				"style": {
					"marginTop": "6px"
				},
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			}],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 10,
							"offset": 1
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}


	import formmain from '@_system/components/base/formmain.vue'
	import formBase from '@_system/components/base/form.vue'
	export default {
		name: 'formForm',
		extends: formBase,
		props: {

		},
		data() {
			return {
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
				}
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {

				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {

					let res = JSON.parse(JSON.stringify(formRes))
					this.rule = res.rule
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height

					this.openwindow()


				})
			},



			regestEvent(rule, fApi) {
				fApi.updateRule('build', {
					on: {
						click: this.build
					}
				})
				fApi.updateRule('getcolumns', {
					on: {
						click: this.getcolumns
					}
				})
			},
			get() {
				this.loading = false
				return new Promise((reslove)=>{
					this.$api[this.name].get(parseInt(this.id)).then((res) => {
						this.sourceData = {listfield:res.listfield	}		
						this.loading = false
						reslove()
					}, () => {		
						reslove()
						this.hide()
					})
				})
			},
			
			beforeSubmit(formData, next) {
				formData.listfield = JSON.stringify(formData.listfield)
				next()
			},
			getcolumns() {
				if (this.$api[this.extra.controller] && this.$api[this.extra.controller].init) {
					this.$api[this.extra.controller].init({
						mode: 'listfield'
					}).then((res) => {
						this.fApi.setValue('listfield', res)

					})
				} else {
					this.$message.error('接口不存在')
				}

			},
			formBack() {
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
			}
			// submit() {
			// 	this.fApi.submit((formData) => {
			// 		formData.rule = JSON.stringify(formData.rule)
			// 		if (this.id == 0) {
			// 			this.save(formData)
			// 		} else {
			// 			this.update(formData)
			// 		}
			// 	})
			// }
		},
		components: {
			formmain
		}
	}
</script>
